export class ChangeHnPcpRequest {
    public HealthNetworkPlanCode: string;
    public ProviderId: string;
    public ProviderName: string;
    public ReasonForChange: string;
    public ChangeEffectiveDate: Date;
    public NoteForChangePCP: string;
}